define.alias("shared/components/shared/post/profile-selector/social-profile-state", "media/components/shared/post/profile-selector/social-profile-state/index");